export const MarkerTooltip = ({
  name,
  showError,
  children,
}: {
  name: string;
  showError: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div className="pointer-events-none relative">
      {children}
      <div
        className={`absolute bottom-[5px] left-[5px] z-10000 whitespace-nowrap rounded-lg rounded-bl-none py-1 pl-1.5 pr-2 text-[12px]/[12px] font-medium text-white ${
          showError
            ? 'bg-red'
            : 'bg-gray-90 opacity-0 transition-opacity group-hover:opacity-100'
        }`}
      >
        {showError ? <AttentionIcon className="text-white" /> : <>{name}</>}
      </div>
    </div>
  );
};

function AttentionIcon({ className }: { className: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M9.9917 18.5815C8.81852 18.5815 7.71452 18.3574 6.67969 17.9092C5.64486 17.4665 4.73177 16.8494 3.94043 16.0581C3.15462 15.2668 2.5376 14.3537 2.08936 13.3188C1.64111 12.284 1.41699 11.18 1.41699 10.0068C1.41699 8.83366 1.64111 7.72965 2.08936 6.69482C2.5376 5.65999 3.15462 4.74967 3.94043 3.96387C4.73177 3.17253 5.64209 2.55273 6.67139 2.10449C7.70622 1.65625 8.81022 1.43213 9.9834 1.43213C11.1621 1.43213 12.2689 1.65625 13.3037 2.10449C14.3385 2.55273 15.2516 3.17253 16.043 3.96387C16.8343 4.74967 17.4541 5.65999 17.9023 6.69482C18.3506 7.72965 18.5747 8.83366 18.5747 10.0068C18.5747 11.18 18.3506 12.284 17.9023 13.3188C17.4541 14.3537 16.8343 15.2668 16.043 16.0581C15.2516 16.8494 14.3385 17.4665 13.3037 17.9092C12.2689 18.3574 11.1649 18.5815 9.9917 18.5815ZM9.9917 16.8882C10.9491 16.8882 11.8428 16.7111 12.6729 16.3569C13.5029 16.0028 14.2334 15.5103 14.8643 14.8794C15.4951 14.2485 15.9876 13.5181 16.3418 12.688C16.696 11.8579 16.873 10.9642 16.873 10.0068C16.873 9.05501 16.696 8.16406 16.3418 7.33398C15.9876 6.49837 15.4951 5.76514 14.8643 5.13428C14.2334 4.50342 13.5002 4.0109 12.6646 3.65674C11.8345 3.30257 10.9408 3.12549 9.9834 3.12549C9.03158 3.12549 8.13786 3.30257 7.30225 3.65674C6.47217 4.0109 5.74447 4.50342 5.11914 5.13428C4.49382 5.76514 4.00407 6.49837 3.6499 7.33398C3.29574 8.16406 3.11865 9.05501 3.11865 10.0068C3.11865 10.9642 3.29574 11.8579 3.6499 12.688C4.00407 13.5181 4.49382 14.2485 5.11914 14.8794C5.75 15.5103 6.48047 16.0028 7.31055 16.3569C8.14616 16.7111 9.03988 16.8882 9.9917 16.8882ZM9.9917 11.3848C9.51025 11.3848 9.26123 11.1413 9.24463 10.6543L9.12842 6.62012C9.11735 6.37663 9.19206 6.17741 9.35254 6.02246C9.51302 5.86751 9.72054 5.79004 9.9751 5.79004C10.2297 5.79004 10.4399 5.87028 10.606 6.03076C10.772 6.18571 10.8494 6.38216 10.8384 6.62012L10.7056 10.6543C10.6945 11.1413 10.4565 11.3848 9.9917 11.3848ZM9.9917 14.1406C9.72054 14.1406 9.48812 14.0549 9.29443 13.8833C9.10628 13.7062 9.01221 13.4876 9.01221 13.2275C9.01221 12.9674 9.10628 12.7516 9.29443 12.5801C9.48812 12.403 9.72054 12.3145 9.9917 12.3145C10.2573 12.3145 10.4842 12.4002 10.6724 12.5718C10.866 12.7433 10.9629 12.9619 10.9629 13.2275C10.9629 13.4932 10.866 13.7118 10.6724 13.8833C10.4787 14.0549 10.2518 14.1406 9.9917 14.1406Z" />
    </svg>
  );
}
